export const GET_USER_CONTACTS_GETTER = "getUserContacts";

export default {

};
